import React from 'react';
import { CalendarDays, ChartNoAxesCombined, House, Sparkles, UserRound } from 'lucide-react';
import { haptic } from '../lib/telegram';
import './BottomNav.css';

export type TabKey = 'dashboard' | 'progress' | 'calendar' | 'ai' | 'profile';

interface BottomNavProps {
  active: TabKey;
  onChange: (tab: TabKey) => void;
}

const TABS = [
  { key: 'dashboard' as const, label: 'Пробежки', Icon: House },
  { key: 'progress' as const, label: 'Прогресс', Icon: ChartNoAxesCombined },
  { key: 'calendar' as const, label: 'Календарь', Icon: CalendarDays },
  { key: 'ai' as const, label: 'Разбор', Icon: Sparkles },
  { key: 'profile' as const, label: 'Профиль', Icon: UserRound }
];

export const BottomNav: React.FC<BottomNavProps> = ({ active, onChange }) => {
  const handle = (tab: TabKey) => {
    if (tab === active) {
      haptic.light();
      return;
    }
    haptic.selection();
    onChange(tab);
  };

  return (
    <nav className="bottom-nav" role="tablist">
      {TABS.map(({ key, label, Icon }) => (
        <button
          key={key}
          role="tab"
          aria-selected={active === key}
          aria-label={label}
          className={`bottom-nav-item ${active === key ? 'active' : ''}`}
          onClick={() => handle(key)}
        >
          <Icon className="bottom-nav-icon" aria-hidden="true" />
          <span className="bottom-nav-label">{label}</span>
        </button>
      ))}
    </nav>
  );
};
